/**
 * Soglia minima per considerare attendibile un tempo proveniente da eSolver.
 * Valori sotto questa soglia (tempo totale / quantità ordine) indicano
 * un dato mancante o non significativo.
 */
const SOGLIA_TEMPO_ATTENDIBILE = 0.003;

/**
 * Verifica se un valore di tempo proveniente da eSolver è non attendibile.
 *
 * Restituisce true se:
 * - il valore è assente (null, undefined, stringa vuota, stringa di soli spazi)
 * - il valore numerico è < 0,003 (esclusivo)
 *
 * Il campo tempo da eSolver può arrivare come number o come stringa anomala
 * (es. spazio inserito manualmente nel gestionale).
 */
export function isTempoNonAttendibile(valore: number | string | null | undefined): boolean {
    if (valore === null || valore === undefined) {
        return true;
    }

    if (typeof valore === "string") {
        if (valore.trim() === "") {
            return true;
        }
        const parsed = parseFloat(valore);
        if (isNaN(parsed)) {
            return true;
        }
        return parsed < SOGLIA_TEMPO_ATTENDIBILE;
    }

    return valore < SOGLIA_TEMPO_ATTENDIBILE;
}
